const transformer = function (origin) {
  return {
    render: 'media',
    value: origin,
    origin,
  }
}

export default transformer
